/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_NoInputs */

const en_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_new_project_confirm_no = /** @type {(inputs: New_Project_Confirm_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {New_Project_Confirm_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_no = /** @type {((inputs?: New_Project_Confirm_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_confirm_no(inputs)
	if (locale === "de") return de_new_project_confirm_no(inputs)
	if (locale === "it") return it_new_project_confirm_no(inputs)
	if (locale === "ru") return ru_new_project_confirm_no(inputs)
	if (locale === "es") return es_new_project_confirm_no(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_confirm_no(inputs)
	if (locale === "ja") return ja_new_project_confirm_no(inputs)
	if (locale === "hi") return hi_new_project_confirm_no(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_confirm_no(inputs)
	return en_new_project_confirm_no(inputs)
});